export default function Strengths() {
  const strengths = [
    {
      icon: 'ri-tools-line',
      title: '自社職人による丁寧な施工',
      description: '下請けには任せない、6,500件のノウハウを持つ自社職人が責任を持って施工します。'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: '専門店直販価格',
      description: '中間マージンをカットした適正価格。専門店だからこそ実現できる価格設定です。'
    },
    {
      icon: 'ri-map-pin-2-line',
      title: '船橋市限定だから即対応',
      description: '移動コストを削減し、緊急時も即座に駆けつけます。地域密着だからこその安心感。'
    }
  ];

  return (
    <section id="strengths" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1a2b4a] mb-12 text-center lg:text-left">
              水回りリフォーム専門店<br />だから出来ること
            </h2>

            <div className="space-y-6">
              {strengths.map((strength, index) => (
                <div key={index} className="bg-[#f5f5f5] rounded-2xl p-8 flex gap-6 hover:shadow-lg transition-shadow">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-[#ff8c42] rounded-full flex items-center justify-center">
                      <i className={`${strength.icon} text-3xl text-white`}></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#1a2b4a] mb-3">{strength.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{strength.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 p-6 bg-[#faf8f5] rounded-2xl border-l-4 border-[#ff8c42]">
              <p className="text-gray-700 leading-relaxed">
                <span className="font-bold text-[#ff8c42]">船橋市のみに絞っているから</span>、移動コストを削減し、緊急時も即対応可能。地域に根ざした信頼のパートナーとして、長くお付き合いいただけます。
              </p>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <div className="absolute inset-0 bg-[#1a2b4a]/20 z-10"></div>
              <img 
                src="https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/1f5f599b4f7f932b831540739ff474e9.jpeg"
                alt="自社職人による丁寧な施工"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-8 left-8 right-8 z-20">
                <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-xl">
                  <p className="text-[#1a2b4a] font-bold text-lg">自社職人による丁寧な施工</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}